import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import HomeTab from './HomeTab';
import MyAssetsCard from './MyAssetsCard';
import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';

interface IProps {
  totalBalance: string;
  trxAddress: string;
  activities: ViewModel.IResponseActivity[];
  isNotActivities: boolean;
  trxAsset?: ViewModel.IAsset;
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  trxKrw: string;
  tokenKrw: string;
  activeTab: ViewModel.HomeTabType;
  isSendingAsset: boolean;
  dbsBuyCount: string;
  dbsBuyCountKRW: string;
  trxPrice: number;
  tokenPrice: number;
  isTransactionErrorModalOpen: boolean;
  transactionErrorMessage: string;
  onClickActiveTab: (tab: ViewModel.HomeTabType) => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: HomeViewType) => void;
  onClickSendBtn: () => void;
  onClickPrevTransactionBtn: () => void;
  onClickTransactionErrorModalClose: () => void;
}

const MainView = ({
  totalBalance,
  trxAddress,
  activities,
  isNotActivities,
  trxAsset,
  tokenAsset,
  trxBalance,
  tokenBalance,
  trxKrw,
  tokenKrw,
  activeTab,
  isSendingAsset,
  dbsBuyCount,
  dbsBuyCountKRW,
  trxPrice,
  tokenPrice,
  isTransactionErrorModalOpen,
  transactionErrorMessage,
  onClickActiveTab,
  onClickCopyBtn,
  onClickResetBtn,
  onClickViewType,
  onClickSendBtn,
  onClickPrevTransactionBtn,
  onClickTransactionErrorModalClose,
}: IProps) => {
  return (
    <>
      <div className="container">
        <MyAssetsCard
          totalBalance={totalBalance}
          trxAddress={trxAddress}
          isSendingAsset={isSendingAsset}
          dbsBuyCount={dbsBuyCount}
          dbsBuyCountKRW={dbsBuyCountKRW}
          onClickCopyBtn={onClickCopyBtn}
          onClickResetBtn={onClickResetBtn}
          onClickSendBtn={onClickSendBtn}
          onClickViewType={onClickViewType}
        />
        <HomeTab
          trxKrw={trxKrw}
          tokenKrw={tokenKrw}
          trxBalance={trxBalance}
          tokenBalance={tokenBalance}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          activities={activities}
          isNotActivities={isNotActivities}
          activeTab={activeTab}
          trxPrice={trxPrice}
          tokenPrice={tokenPrice}
          onClickViewType={onClickViewType}
          onClickActiveTab={onClickActiveTab}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
        />
      </div>

      {/* 트랜잭션 에러 모달 */}
      <div
        className={clsx('modal-overlay', !isTransactionErrorModalOpen && 'hidden')}
        id="transactionErrorModal"
      >
        <div className="modal-content modal-medium">
          <button type="button" className="modal-close" onClick={onClickTransactionErrorModalClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <div className="modal-icon-warning">
              <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
            </div>

            <h2
              className="modal-warning-title text-lg font-bold"
              dangerouslySetInnerHTML={{ __html: transactionErrorMessage }}
            />

            <button
              type="button"
              className="modal-button text-lg font-semibold"
              onClick={onClickTransactionErrorModalClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainView;
